'use client';

import type { WebshopUserCapiSubscribeEvent } from '@cldsystems/ws-api-client';
import { useCallback } from 'react';

import { useCookiebotConsent } from '@/hooks/use-cookiebot-consent';
import { postCapiSubscribe } from '@/utils/capi-tracking';

type CapiSubscribeInput = WebshopUserCapiSubscribeEvent;

export function useCapiSubscribe() {
  const hasMarketingConsent = useCookiebotConsent('marketing');

  const trackSubscribe = useCallback(
    (input: CapiSubscribeInput) => {
      if (!hasMarketingConsent) {
        return;
      }

      void postCapiSubscribe({
        ...input,
        sourceUrl: input.sourceUrl ?? window.location.href,
      });
    },
    [hasMarketingConsent],
  );

  return { trackSubscribe };
}
